import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class TabsSwitch extends MainComponent {
    static propTypes = {
        tab: PropTypes.number,
        links: PropTypes.array,
        tabs: PropTypes.array,
        pages: PropTypes.array,
        className: PropTypes.string,
        onBeforeChange: PropTypes.func,
        onChange: PropTypes.func,
    };
    static defaultProps = {
        tab: 0,
        links: [],
        tabs: [],
        pages: [],
        className: "",
        onBeforeChange: null,
        onChange: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            index: this.props.tab
        };

        this.useTooltip = true;
    }

    get tabKey() {
        return this.props.links[this.state.index];
    }

    setTab(link) {
        const { links } = this.props;
        const index = links.indexOf(link);

        if (index > -1)
            this.changeIndex(index);
    }

    changeIndex(index) {
        if (this.state.index === index)
            return;

        const tab = this.props.links[index];

        if (this.props.onBeforeChange?.apply)
            this.props.onBeforeChange(tab);

        this.setState({ index }, () => {
            if (this.props.onChange?.apply)
                this.props.onChange(tab);
        });
    }

    render() {
        const { tabs, pages, className } = this.props;
        const { index } = this.state;
        const page = pages[index];

        return (
            <div className={`tabsSwitch flex col ${className}`}>
                <div className="tabs flex text p1SemiBold">
                    {tabs.map((text, i) => {
                        const tabState = i === index ? "active" : "hand";
                        const fn = i === index ? null : this.changeIndex.bind(this, i);

                        return (
                            <div
                                key={i}
                                className={`tab flex1 transit06 ${tabState}`}
                                onClick={fn}
                            >
                                {this.tr(text)}
                            </div>
                        );
                    })}
                </div>
                {page?.apply ? page() : page}
            </div>
        );
    }
}
